import { render, staticRenderFns } from "./logoSaven.vue?vue&type=template&id=69bbdb3d&scoped=true&"
import script from "./logoSaven.vue?vue&type=script&lang=js&"
export * from "./logoSaven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bbdb3d",
  null
  
)

export default component.exports